import { SplashScreen } from '@capacitor/splash-screen';
import { SPLASH_FAILSAFE_MS } from './live-update-startup';

let splashFailsafeId: number | undefined;

/** Absolute upper bound so the native splash can never stick forever. */
export const startSplashFailsafe = (ms: number = SPLASH_FAILSAFE_MS) => {
  clearSplashFailsafe();
  splashFailsafeId = window.setTimeout(() => {
    SplashScreen.hide().catch(() => undefined);
  }, ms);
};

export const clearSplashFailsafe = () => {
  if (splashFailsafeId !== undefined) {
    window.clearTimeout(splashFailsafeId);
    splashFailsafeId = undefined;
  }
};
